import { gql } from '@apollo/client';

export type {
  GetPurchaseAgreementUrl as IGetPurchaseAgreementUrl,
  GetPurchaseAgreementUrlVariables as IGetPurchaseAgreementUrlVariables,
} from './__generated__/GetPurchaseAgreementUrl';

export const GET_PURCHASE_AGREEMENT_URL = gql`
  query GetPurchaseAgreementUrl($referralUUID: String!) {
    purchaseAgreementUrl(referralUUID: $referralUUID)
  }
`;
